var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{ 'container-user': !_vm.isExpert && ! _vm.isAdmin }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col bg-app-gray padding-0 my-custom-col"},[(_vm.isExpert)?_c('expert-home'):(_vm.isAdmin)?_c('admin-home'):_c('user-home')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }